import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCtWatchlist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M18.918 8.865h-2.717A1.864 1.864 0 0 1 14.338 7V3.597H4.892c-.605 0-1.095.49-1.095 1.095v14.615c0 .604.49 1.094 1.095 1.094h7.69a.799.799 0 0 1 0 1.598h-7.69A2.692 2.692 0 0 1 2.2 19.306V4.692A2.692 2.692 0 0 1 4.892 2h9.985c.847 0 1.645.399 2.153 1.077l2.947 3.929c.35.466.538 1.032.538 1.615v2.846a.799.799 0 1 1-1.597 0V8.865Zm-.741-1.598L15.934 4.28V7c0 .147.12.266.266.266h1.976Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M11.518 9.987a.799.799 0 1 0 0-1.598H6.193a.799.799 0 1 0 0 1.598h5.325ZM12.316 13.448a.799.799 0 0 1-.798.798H6.193a.799.799 0 1 1 0-1.597h5.325c.44 0 .798.358.798.799Z"
    />
    <path
      fill="#F7A600"
      d="M17.904 13.479c.163-.527.909-.527 1.072 0l.846 2.74h2.816c.536 0 .767.68.34 1.006l-2.301 1.759.864 2.796c.162.522-.442.944-.877.612l-2.224-1.7-2.225 1.7c-.434.332-1.038-.09-.877-.611l.865-2.797-2.302-1.759a.561.561 0 0 1 .34-1.007h2.816l.847-2.739Z"
    />
  </svg>
);
export default SvgTwoColorCtWatchlist;
